import { useState } from "react";
import { changePassword } from "../api.ts";

/**
 * 改口令。两种出场方式:
 *
 *   · **强制**(`onCancel` 不传):口令是管理员或平台方设好告诉本人的,登录后第一屏就是它,
 *     没有关闭按钮。后端同样只放行改口令接口,这里只是不让人看见用不了的页面。
 *   · **自愿**:从顶栏打开,可以取消。
 *
 * 再输一遍新口令不是走形式:口令框看不见输入,打错一位的话,下次登录就进不来了 ——
 * 而能帮他重置的人往往就是当初设口令的那个人。
 */
export function ChangePassword(props: {
  onDone: () => void;
  onCancel?: () => void;
  onLogout?: () => void;
}): React.JSX.Element {
  const forced = !props.onCancel;
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);

  const mismatch = confirm.length > 0 && next !== confirm;
  const ready = current && next.length >= 8 && next === confirm;

  const submit = async (): Promise<void> => {
    setErr(""); setBusy(true);
    try {
      await changePassword(current, next);
      // 强制那一屏改完直接进工作台就是反馈;自愿改的留一句确认,不然弹窗一关看不出成没成
      if (forced) props.onDone(); else setSaved(true);
    } catch (e) {
      setErr((e as Error).message);
    } finally { setBusy(false); }
  };

  if (saved) return (
    <div className="modal-bg" onClick={props.onDone}>
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="password-title" onClick={(e) => e.stopPropagation()}>
        <div className="mt" id="password-title">口令已修改</div>
        <div className="ms">其它设备上的登录已失效，下次登录请使用新口令。</div>
        <div className="foot"><button type="button" className="b p" onClick={props.onDone} autoFocus>完成</button></div>
      </div>
    </div>
  );

  return (
    <div className="modal-bg" onClick={forced ? undefined : props.onCancel}>
      <form className="modal password-form" role="dialog" aria-modal="true" aria-labelledby="password-title"
        onClick={(e) => e.stopPropagation()} onSubmit={(e) => { e.preventDefault(); void submit(); }}>
        <div className="mt" id="password-title">{forced ? "请先修改初始口令" : "修改口令"}</div>
        <div className="ms">
          {forced
            ? "当前口令是管理员为你设置的。改成只有你自己知道的口令后才能继续使用。"
            : "修改后，其它设备上的登录会失效，当前设备保持登录。"}
        </div>

        {err && <div className="err">{err}</div>}

        <label htmlFor="pw-current">{forced ? "初始口令" : "当前口令"}</label>
        <input id="pw-current" className="in" type="password" autoComplete="current-password"
          value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus />

        <label htmlFor="pw-next">新口令</label>
        <input id="pw-next" className="in" type="password" autoComplete="new-password"
          value={next} onChange={(e) => setNext(e.target.value)} aria-describedby="pw-next-hint" />
        <div className="password-hint" id="pw-next-hint">至少 8 位</div>

        <label htmlFor="pw-confirm">再输一遍新口令</label>
        <input id="pw-confirm" className={`in${mismatch ? " err" : ""}`} type="password" autoComplete="new-password"
          value={confirm} onChange={(e) => setConfirm(e.target.value)} aria-invalid={mismatch} />
        {mismatch && <div className="password-hint danger-text">两次输入的新口令不一致</div>}

        <div className="foot">
          {forced
            ? props.onLogout && <button type="button" className="b q" onClick={props.onLogout}>退出登录</button>
            : <button type="button" className="b q" onClick={props.onCancel}>取消</button>}
          <button type="submit" className="b p" disabled={!ready || busy}>{busy ? "保存中…" : "保存新口令"}</button>
        </div>
      </form>
    </div>
  );
}
